import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useOutletContext, useParams } from "react-router-dom";
import { searchStocksApi } from "../api/user";
import Loader from "../components/Loader";
import DashboardHeader from "../components/Other/DashboardHeader";
import TopbarSearch from "../components/Sidebar/TopbarSearch";
import PageContainer from "../components/pages/PageContainer";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";

const SearchPage = () => {
  const { t } = useTranslation();
  const [stocksData, setStockData] = useState([]);
  const [loader, setLoader] = useState(false);
  const { term } = useParams();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const searchItem = localStorage.getItem("searchItem");

  const [search, setSearch] = useState(
    term ? term : searchItem ? searchItem : ""
  );

  useEffect(() => {
    setSearch(searchItem);
  }, [searchItem]);

  const [scButton, setScButton] = useState(false);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const clearSearch = () => {
    search.current.value = "";
    setScButton(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    const res = await searchStocksApi(search);
    if (res && res?.data.status === 200) {
      setStockData(res?.data?.data);
      setLoader(false);
    } else {
      setLoader(false);
    }
  };

  const [sidebarToggle] = useOutletContext();
  const pathSegments = window.location.pathname.split("/");

  return (
    <>
      <DashboardHeader
        toggle={sidebarToggle}
        searchVal={term}
        setStocksData={setStockData}
        setLoader={setLoader}
      />
      {window.location.pathname === "/auth/trending-stocks" ? (
        <PageHeaderTitle title={t("Today’s Movers")} />
      ) : (
        <PageHeaderTitle title={t("Search Stocks")} />
      )}
      <PageContainer>
        {isMobileView && (
          <TopbarSearch
            clearSearch={clearSearch}
            handleChange={handleChange}
            scButton={scButton}
            search={search}
            handleSubmit={handleSubmit}
            isMobileView={isMobileView}
          />
        )}
        <div className="mt-1 md:block  rounded-2xl bg-white max-w-[60rem] mx-auto  mb-24">
          <main
            className={
              isMobileView
                ? "h-full bg-white justify-center"
                : "h-full bg-white pt-4 justify-center"
            }
          >
            <div
              className={
                isMobileView
                  ? "px-3 max-w-[8-rem] mx-auto"
                  : "p-8 max-w-[8-rem] mx-auto"
              }
            >
              <div className="flex flex-col gap-4 w-full md:w-full">
                {pathSegments[1] === "auth" &&
                pathSegments[2] === "trending-stocks" ? (
                  <>
                    {!loader && stocksData && stocksData.length > 0 ? (
                      stocksData.map((stock, index) => (
                        <Link
                          key={stock.stock_symbol}
                          to={`/chartSearch/${stock?.stock_symbol}`}
                        >
                          <div className="flex flex-col w-full">
                            <div className="flex flex-row items-center justify-between gap-4">
                              <div className="text-xs md:text-sm w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                <div className="text-primaryColor font-bold">
                                  {stock?.stock_symbol}
                                </div>
                                <div className="text-ellipsis overflow-hidden text-gray-400">
                                  {stock && stock.stock_name ? (
                                    stock.stock_name
                                  ) : (
                                    <span style={{ opacity: 0 }}>N/A</span>
                                  )}
                                </div>
                              </div>
                              <div
                                className={`items-center text-xs md:text-sm w-full justify-center ${
                                  stock.percentageChange < 0
                                    ? "text-red-500"
                                    : "text-green-500"
                                }`}
                                style={{ maxWidth: "100px" }}
                              >
                                <div className="text-center font-semibold overflow-hidden text-overflow-ellipsis whitespace-nowrap">
                                  $
                                  {stock?.latestData?.c
                                    .toFixed(2)
                                    .toLocaleString("en-US")}
                                </div>
                                <div className={`text-center  text-xs`}>
                                  {stock.percentageChange < 0 ? "▼" : "▲"}
                                  {Math.abs(stock.percentageChange).toFixed(2)}%
                                </div>
                              </div>
                              <div className="text-right text-xs md:text-sm w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                <div className="text-primaryColor font-bold">
                                  ${stock?.total_trading_value}
                                </div>
                                <div className="text-gray-400">
                                  {stock.total_stock_value} shares
                                </div>
                              </div>
                            </div>

                            <div className="border-t border-gray-300 w-full my-2" />
                          </div>
                        </Link>
                      ))
                    ) : loader ? (
                      <Loader />
                    ) : (
                      <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                        <p>No Data Found</p>
                      </div>
                    )}
                  </>
                ) : pathSegments[1] === "search" ? (
                  <>
                    {!loader && stocksData && stocksData.length > 0 ? (
                      stocksData.map((stock, index) => (
                        <Link to={`/chartSearch/${stock?.stock_symbol}`}>
                          <div className="flex flex-col w-full">
                            <div className="flex flex-row items-center justify-between gap-4">
                              <div className="text-xs md:text-sm w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                <div className="text-primaryColor font-bold">
                                  {stock?.stock_symbol}
                                </div>
                                <div className="text-ellipsis overflow-hidden text-gray-400">
                                  {stock && stock.stock_name ? (
                                    stock.stock_name
                                  ) : (
                                    <span style={{ opacity: 0 }}>N/A</span>
                                  )}
                                </div>
                              </div>
                              <div
                                className={`items-center text-xs md:text-sm w-full justify-center ${
                                  stock.percentageChange < 0
                                    ? "text-red-500"
                                    : "text-green-500"
                                }`}
                                style={{ maxWidth: "100px" }}
                              >
                                <div className="text-center font-semibold overflow-hidden text-overflow-ellipsis whitespace-nowrap">
                                  $
                                  {stock?.latestData?.c
                                    .toFixed(2)
                                    .toLocaleString("en-US")}
                                </div>
                                <div className={`text-center text-xs`}>
                                  {stock.percentageChange < 0 ? "▼" : "▲"}
                                  {Math.abs(stock.percentageChange).toFixed(2)}%
                                </div>
                              </div>
                              <div className="text-right text-xs md:text-sm w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
                                <div className="text-primaryColor font-bold">
                                  ${stock?.total_trading_value}
                                </div>
                                <div className="text-gray-400">
                                  {stock.total_stock_value} shares
                                </div>
                              </div>
                            </div>

                            <div className="border-t border-gray-300 w-full my-2" />
                          </div>
                        </Link>
                      ))
                    ) : loader ? (
                      <Loader />
                    ) : (
                      <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                        <p>No Data Found</p>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                    <p>No Data Found</p>
                  </div>
                )}
              </div>
            </div>
          </main>
        </div>
      </PageContainer>
    </>
  );
};

export default SearchPage;
